import React, { useState } from "react";
import { useGroundTruthsWithPatients } from "hooks/aiReviewTest/useGroundTruthsWithPatients";
import { GroundTruthFilters, CreateGroundTruthDto } from "services/api/aiReviewTest/groundTruthApi";
import { GroundTruth } from "common/models/types";
import AdminGroundTruthTemplate from "components/templates/AdminGroundTruthTemplate";
import GroundTruthListSection from "components/organisms/GroundTruthListSection";
import GroundTruthFormModal from "components/organisms/GroundTruthFormModal";
import ExperimentExecuteModal from "components/organisms/ExperimentExecuteModal";
import { ConfirmManager } from "components/organisms/CommonUI";
import { Button } from "components/atoms";
import { useCreateExperiment } from "hooks/aiReviewTest/useExperiments";
import { CreateExperimentDto } from "types/aiReviewTest";
import { useNavigate } from "react-router-dom";

const AdminGroundTruthsPage: React.FC = () => {
  const [filters, setFilters] = useState<GroundTruthFilters>({});
  const navigate = useNavigate();
  const createExperimentMutation = useCreateExperiment();

  const { groundTruths, isLoading, createGroundTruth, updateGroundTruth, deleteGroundTruth } =
    useGroundTruthsWithPatients(filters);

  console.log("AdminGroundTruthsPage - final groundTruths:", groundTruths);
  console.log("AdminGroundTruthsPage - isLoading:", isLoading);

  const handleCreateClick = () => {
    ConfirmManager.show({
      body: (
        <GroundTruthFormModal
          onConfirm={async (data) => {
            if ("patientId" in data) {
              await createGroundTruth(data as CreateGroundTruthDto);
            }
            ConfirmManager.hide();
          }}
          onCancel={() => {
            ConfirmManager.hide();
          }}
        />
      ),

      showBackdrop: true,
      backdropClose: true,
      showCloseButton: false,
    });
  };

  const handleEditClick = (groundTruth: GroundTruth) => {
    ConfirmManager.show({
      body: (
        <GroundTruthFormModal
          groundTruth={groundTruth}
          onConfirm={async (data) => {
            await updateGroundTruth({ 
              id: groundTruth.id!, 
              data: {
                patientId: data.patientId,
                promptType: data.promptType,
                expectedContent: data.expectedContent
              }
            });
            ConfirmManager.hide();
          }}
          onCancel={() => {
            ConfirmManager.hide();
          }}
        />
      ),
      showBackdrop: true,
      backdropClose: true,
      showCloseButton: false,
    });
  };

  const handleDeleteClick = (id: number) => {
    ConfirmManager.show({
      title: "Ground Truth 삭제",
      body: "정말로 이 Ground Truth를 삭제하시겠습니까?",
      buttons: [
        <Button
          size="Medium"
          type="Text"
          variant="Ghost"
          color="Secondary"
          onClick={() => ConfirmManager.hide()}
        >
          취소
        </Button>,
        <Button
          size="Medium"
          type="Text"
          variant="Contained"
          color="Negative"
          onClick={async () => {
            await deleteGroundTruth(id);
            ConfirmManager.hide();
          }}
        >
          삭제
        </Button>,
      ],
      showBackdrop: true,
      backdropClose: true,
      showCloseButton: false,
    });
  };

  const handleExperimentClick = () => {
    ConfirmManager.show({
      body: (
        <ExperimentExecuteModal
          onConfirm={async (experimentDto: CreateExperimentDto) => {
            await createExperimentMutation.mutateAsync(experimentDto);
            ConfirmManager.hide();
            // 결과 페이지로 이동 (추후 구현)
            // navigate(`/admin/ai-review-test/results`);
          }}
          onCancel={() => {
            ConfirmManager.hide();
          }}
        />
      ),
      showBackdrop: true,
      backdropClose: false,
      showCloseButton: false,
    });
  };

  return (
    <AdminGroundTruthTemplate>
      <GroundTruthListSection
        groundTruths={groundTruths}
        isLoading={isLoading}
        filters={filters}
        onFiltersChange={setFilters}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        onExperimentClick={handleExperimentClick}
      />
    </AdminGroundTruthTemplate>
  );
};

export default AdminGroundTruthsPage;
